import cardValidator from 'card-validator'
import {t} from '@/form.js'

// CVV is exactly 3 digits: the input mask caps typing at 3, the validator
// rejects anything shorter.
export const CVV_LENGTH = 3

export const PAYMENT_FIELD_NAMES = {
  cardNumber: "cardNumber",
  expDate: "exp-date",
  cvv2: "cvv2",
  nameoncard: "nameoncard"
}

cardValidator.creditCardType.addCard({
  niceType: "HUMO",
  type: "HUMO",
  gaps: [4, 8, 12],
  lengths: [16],
  code: {name: "CVV", size: 0},
  patterns: [9860],
})

cardValidator.creditCardType.addCard({
  niceType: "UZCARD",
  type: "UZCARD",
  gaps: [4, 8, 12],
  lengths: [16, 18],
  code: {name: "CVV", size: 0},
  patterns: [86],
})

/**
 * Payment system recognised by the BIN, or '' while the prefix still matches
 * more than one system (`card-validator` fills `card` only once it is sure).
 */
export function getCardBrand(value) {
  return cardValidator.number(value).card?.type ?? ''
}

export const validate = {
  intl: {},
  cardValid: false,
  cardMaxLength: 19,
  nameRequired: false,

  [PAYMENT_FIELD_NAMES.cardNumber](value, state, isActive) {
    let next = false
    const errors = []

    if (cardValidator.number(value).isValid) {
      next = PAYMENT_FIELD_NAMES.expDate
    }

    if (cardValidator.number(value).isPotentiallyValid && isActive) {
      return {
        fixedValue: value,
        errors,
        next,
      }
    }

    if (value.length === 0) {
      errors.push(t('FormError:Card.pan.required'))
    }
    if (!cardValidator.number(value).isValid) {
      errors.push(t('FormError:Card.pan.invalid'))
    }

    return {
      fixedValue: value,
      errors,
      next,
    }
  },

  [PAYMENT_FIELD_NAMES.nameoncard](value) {
    const errors = []

    if (this.nameRequired && value.length === 0) {
      errors.push(t('FormError:Card.name.required'))
    }

    if (value.length && !value.match(/^[a-zA-Z. -]{0,30}$/)) {
      errors.push(t('FormError:Card.name.invalid'))
    }
    return {
      fixedValue: value,
      errors,
    }
  },

  [PAYMENT_FIELD_NAMES.expDate]: (value, state, isActive) => {
    let next = false
    const errors = []

    let fixedValue = value.replace(/ /g, '').replace(/\//g, '')
    if (fixedValue.slice(2).length === 4) {
      fixedValue = `${fixedValue.slice(0, 2)}${fixedValue.slice(4)}`
    }
    const month = fixedValue.slice(0, 2)
    const year = fixedValue.slice(2)

    if (year.length === 2 && cardValidator.expirationMonth(month).isValid) {
      if (state.isCvcEnabled) {
        next = PAYMENT_FIELD_NAMES.cvv2
      } else {
        next = PAYMENT_FIELD_NAMES.nameoncard
      }
    }

    if (cardValidator.expirationMonth(month).isPotentiallyValid && isActive) {
      return {
        fixedValue: value,
        errors,
        next,
      }
    }

    if (fixedValue.length === 0) {
      errors.push(t('FormError:Card.expiry.required'))
    }

    if (!cardValidator.expirationMonth(month).isValid || month.length !== 2) {
      errors.push(t('FormError:Card.expiry.month.invalid'))
    }

    if (year.length !== 2) {
      errors.push(t('FormError:Card.expiry.year.invalid'))
    }

    return {
      fixedValue,
      errors,
      next
    }
  },

  [PAYMENT_FIELD_NAMES.cvv2](value, state, isActive) {
    let next = false
    const errors = []

    if (!state.isCvcEnabled) {
      next = PAYMENT_FIELD_NAMES.nameoncard
      return {
        fixedValue: value,
        errors,
        next,
      }
    }

    if (value.length === CVV_LENGTH) {
      next = PAYMENT_FIELD_NAMES.nameoncard
    }

    if (cardValidator.cvv(value).isPotentiallyValid && isActive) {
      return {
        fixedValue: value,
        errors,
        next,
      }
    }

    if (value.length === 0) {
      errors.push(t('FormError:Card.cvc.required'))
    }
    if (value.length !== CVV_LENGTH) {
      errors.push(t('FormError:Card.cvc.invalid'))
    }
    return {
      fixedValue: value,
      errors,
      next,
    }
  },

  captcha_text(value) {
    const errors = []
    if (value.length === 0) {
      errors.push(t('FormError:Card.captcha_text.required'))
    }
    return {
      fixedValue: value,
      errors,
    }
  },

}
